import { zAttrMeta } from "src/business/attribute/ZAttrMeta";
import { maxNameLength, rxName, rxNameMsg } from "src/common/rxName";
import { z } from "zod";

import { zSysDataHistory } from "../sysData/ZSysData";

export type SpecificationType = "primary" | "secondary" | "values";

export const zSpecDef = z.object({
  attributes: zAttrMeta.array(),
});
export type ZSpecDef = z.infer<typeof zSpecDef>;

export const zSpecCategoryOption = z.object({
  code: z.number(),
  label: z.string(),
});
export type ZSpecCategoryOption = z.infer<typeof zSpecCategoryOption>;

export const zSecSpecLinkType = z.object({
  ...zSpecCategoryOption.shape,
  options: zSpecCategoryOption.array().nullish(),
});

export const zSpecCommon = z.object({
  id: z.string(),
  displayId: z.number(),
  name: z
    .string()
    .max(maxNameLength)
    .regex(rxName, { error: rxNameMsg() })
    .describe("Системное название спецификации"),
  displayName: z
    .string()
    .max(maxNameLength)
    .nullish()
    .describe("Название спецификации"),
  description: z.string().nullish(),
  definition: zSpecDef.nullish(),
  linkType: zSecSpecLinkType.nullish(),
});
export type ZSpecCommon = z.infer<typeof zSpecCommon>;

// http://wiki.d4r.int/pages/viewpage.action?pageId=514856801
export const zSpecification = z.object({
  ...zSpecCommon.shape,
  categoryData: z
    .object({
      code: z.number(),
      label: z.string(),
      options: zSpecCategoryOption.array().optional(), // Похоже на неудачное решение и возможно будет удалено
    })
    .optional(),
  ...zSysDataHistory.shape,
});
export type ZSpecification = z.infer<typeof zSpecification>;

export type SpecificationsFilter = {};

export const zSpecResponse = z.object({
  content: zSpecification.array(),
  pagination: z.object({
    totalElements: z.number(),
  }),
});

export const zSpecRelations = z.object({
  schemaId: z.string(),
  hasRelations: z.boolean(),
});
export type ZSpecRelations = z.infer<typeof zSpecRelations>;

const zSpecTypeRaw = z.enum(["PRIMARY", "SECONDARY"]);
export type ZSpecTypeRaw = z.infer<typeof zSpecTypeRaw>;

export const zSpecificationTyped = z.object({
  ...zSpecification.shape,
  type: zSpecTypeRaw,
});
export type ZSpecificationTyped = z.infer<typeof zSpecificationTyped>;

const zPrimSchemaLinkItem = z.object({
  id: z.string(),
  displayId: z.number(),
  name: z.string(),
});

export type ZPrimSchemaLinkItem = z.infer<typeof zPrimSchemaLinkItem>;

const zSecondarySchemaLinkClass = z.object({
  id: z.string(),
  displayId: z.number(),
  className: z.string(),
  classifierName: z.string(),
});

export type ZSecondarySchemaLinkClass = z.infer<
  typeof zSecondarySchemaLinkClass
>;

export const zSchemaLinks = z.object({
  catalogs: zPrimSchemaLinkItem.array().nullish(),
  classifiers: zPrimSchemaLinkItem.array().nullish(),
});
export type ZSchemaLinks = z.infer<typeof zSchemaLinks>;

export const zSecondarySchemaLinks = z.object({
  classes: zSecondarySchemaLinkClass.array().nullish(),
});
export type ZSecondarySchemaLinks = z.infer<typeof zSecondarySchemaLinks>;
